module.exports = __webpack_public_path__ + "static/media/banner3@2x.e53cd51b.png";